import React, {useMemo} from 'react';
import type {DataValue, VerifiedLinkedValueLink} from 'schemaDefinition/types';
import {isLinkedValueLink} from 'schemaDefinition';
import {usePreviewConfigurationContext} from '../contexts';
import {formatLinkedValueLink} from '../functions';
import {useTextValue} from '../hooks';

// type Props = BasePartProps<PartLinkedLiterary>;
type Props = {
  value: DataValue;
};

export const PreviewLinkedEntity: React.FC<Props> = ({value}) => {
  const config = usePreviewConfigurationContext();
  const link = useMemo(() => {
    return isLinkedValueLink(value)
      ? {
          value: formatLinkedValueLink(value) ?? '',
          link: value,
        }
      : undefined;
  }, [value]);

  const TextValue = useTextValue();

  const verifiedLink =
    link?.link.linkStatus === 'verified'
      ? (link.link as VerifiedLinkedValueLink)
      : undefined;
  const onNavigate = config.onNavigate;

  return link ? (
    onNavigate && verifiedLink ? (
      <TextValue onClick={() => onNavigate(verifiedLink)}>
        {link.value}
      </TextValue>
    ) : (
      <TextValue>{link.value}</TextValue>
    )
  ) : null;
};
